













import { defineComponent, PropType } from '@vue/composition-api'

interface AnchorLink {
  id: string
  text: string
  tab: number
}
export default defineComponent({
  props: {
    anchorLinks: {
      type: Array as PropType<AnchorLink[]>,
      required: true,
    },
  },
  setup(_, context) {
    const goToPageAnchor = (tab: number, id: string) => {
      context.emit('goToPageAnchor', tab)
      const headerElement = document.querySelector('#header') as HTMLElement
      const headerHeight = headerElement.offsetHeight

      context.root.$nextTick(() => {
        const targetElement = document.getElementById(id) as HTMLElement
        context.root.$smoothScroll({
          scrollTo: targetElement,
          offset: -headerHeight,
        })
      })
    }
    return {
      goToPageAnchor,
    }
  },
})
